import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { tempUrl } from "../../../contexts/ContextProvider";
import { useStateContext } from "../../../contexts/ContextProvider";
import { AuthContext } from "../../../contexts/AuthContext";
import { ShowTableSuratPenarikan } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import {
  SearchBar,
  Loader,
  ButtonModifier,
  ScrollToTop,
} from "../../../components";
import { Colors } from "../../../constants/styles";
import {
  Box,
  TextField,
  Typography,
  Divider,
  Pagination,
  Chip,
  ButtonGroup,
  Button,
  Autocomplete,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PrintIcon from "@mui/icons-material/Print";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import { Col, Row, Form } from "react-bootstrap";

const TampilSuratPenarikan = () => {
  const { setting, user } = useContext(AuthContext);
  const { dispatch } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };
  const [isFetchError, setIsFetchError] = useState(false);
  const [isStsExist, setIsStsExist] = useState(false);
  const [noSt, setNoSt] = useState("");
  const [tglSt, setTglSt] = useState("");
  const [tglStDate, setTglStDate] = useState("");
  const [noJual, setNoJual] = useState("");
  const [tanggalJual, setTanggalJual] = useState("");
  const [noAngsuran, setNoAngsuran] = useState("");
  const [tenor, setTenor] = useState("");
  const [keterlambatan, setKeterlambatan] = useState("");
  const [denda, setDenda] = useState("");
  const [hutangDendaBefore, setHutangDendaBefore] = useState("");
  const [namaKolektor, setNamaKolektor] = useState("");
  const [kodeKolektor, setKodeKolektor] = useState("");
  const [angPerBulan, setAngPerBulan] = useState("");
  const [jmlBlnTelat, setJmlBlnTelat] = useState("");
  const [totalDenda, setTotalDenda] = useState("");
  const [biayaTarik, setBiayaTarik] = useState("");
  const [namaRegister, setNamaRegister] = useState("");
  const [tahun, setTahun] = useState("");
  const [isi, setIsi] = useState("");
  const [namaWarna, setNamaWarna] = useState("");
  const [noRangka, setNoRangka] = useState("");
  const [noMesin, setNoMesin] = useState("");

  // Delete it
  const [almRegister, setAlmRegister] = useState("");
  const [tlpRegister, setTlpRegister] = useState("");
  const [nopol, setNopol] = useState("");
  const [merk, setMerk] = useState("");
  const [kodeTipe, setKodeTipe] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState("");

  const [value, setValue] = useState("Semua");
  const [searchTerm, setSearchTerm] = useState("");
  const [stsData, setStsData] = useState([]);
  const [kodeKolektorInput, setKodeKolektorInput] = useState("");
  const [kolektors, setKolektors] = useState([]);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const handleChangeFilter = (event) => {
    setValue(event.target.value);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  let findMonth = (monthNumber) => {
    if (monthNumber === 1) {
      return "JANUARI";
    } else if (monthNumber === 2) {
      return "FEBRUARI";
    } else if (monthNumber === 3) {
      return "MARET";
    } else if (monthNumber === 4) {
      return "APRIL";
    } else if (monthNumber === 5) {
      return "MEI";
    } else if (monthNumber === 6) {
      return "JUNI";
    } else if (monthNumber === 7) {
      return "JULI";
    } else if (monthNumber === 8) {
      return "AGUSTUS";
    } else if (monthNumber === 9) {
      return "SEPTEMBER";
    } else if (monthNumber === 10) {
      return "OKTOBER";
    } else if (monthNumber === 11) {
      return "NOVEMBER";
    } else if (monthNumber === 12) {
      return "DESEMBER";
    }
  };

  const kolektorOptions = kolektors.map((kolektor) => ({
    label: `${kolektor.kodeKolektor} - ${kolektor.namaKolektor}`,
  }));

  useEffect(() => {
    id ? getStById() : setIsStsExist(false);
  }, [id]);

  useEffect(() => {
    if (user.tipeUser === "OWN/DIREKSI") {
      getStAllCabangsData();
    } else {
      getStsData();
    }
    getKolektor();
  }, [value, page, searchTerm]);

  const getStAllCabangsData = async () => {
    setLoading(true);
    try {
      // Filter Kolektor/Eksekutor
      const pickedKolektor = await axios.post(`${tempUrl}/kolektorByKode`, {
        kodeKolektorInput,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });

      let tempKodeKolektor;
      if (pickedKolektor.data) {
        tempKodeKolektor = pickedKolektor.data._id;
      }

      if (user.tipeUser === "EKS") {
        tempKodeKolektor = user.kodeKolektor;
      }

      let allSts;
      switch (value) {
        case "Sudah Bayar":
          allSts = await axios.post(
            `${tempUrl}/stAllCabangsPaginationSudahBayar?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
            }
          );
          break;
        case "Belum Bayar":
          allSts = await axios.post(
            `${tempUrl}/stAllCabangsPaginationBelumBayar?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
            }
          );
          break;
        case "PP":
          allSts = await axios.post(
            `${tempUrl}/stAllCabangsPaginationSudahDitarik?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
            }
          );
          break;
        case "Tarik/Titip":
          allSts = await axios.post(
            `${tempUrl}/stAllCabangsPaginationTitip?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
            }
          );
          break;
        default:
          allSts = await axios.post(
            `${tempUrl}/stAllCabangsPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
            }
          );
          break;
      }

      setQuery(searchTerm);
      setStsData(allSts.data.suratPenarikans);
      setPage(allSts.data.page);
      setPages(allSts.data.totalPage);
      setRows(allSts.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getStsData = async () => {
    setLoading(true);
    try {
      // Filter Kolektor/Eksekutor
      const pickedKolektor = await axios.post(`${tempUrl}/kolektorByKode`, {
        kodeKolektorInput,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });

      let tempKodeKolektor;
      if (pickedKolektor.data) {
        tempKodeKolektor = pickedKolektor.data._id;
      }

      if (user.tipeUser === "EKS") {
        tempKodeKolektor = user.kodeKolektor;
      }

      let allSts;
      switch (value) {
        case "Sudah Bayar":
          allSts = await axios.post(
            `${tempUrl}/stsPaginationSudahBayar?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
              kodeCabang: user.cabang._id,
            }
          );
          break;
        case "Belum Bayar":
          allSts = await axios.post(
            `${tempUrl}/stsPaginationBelumBayar?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
              kodeCabang: user.cabang._id,
            }
          );
          break;
        case "PP":
          allSts = await axios.post(
            `${tempUrl}/stsPaginationSudahDitarik?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
              kodeCabang: user.cabang._id,
            }
          );
          break;
        case "Tarik/Titip":
          allSts = await axios.post(
            `${tempUrl}/stsPaginationTitip?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
              kodeCabang: user.cabang._id,
            }
          );
          break;
        default:
          allSts = await axios.post(
            `${tempUrl}/stsPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
              kodeCabang: user.cabang._id,
            }
          );
          break;
      }

      setQuery(searchTerm);
      setStsData(allSts.data.suratPenarikans);
      setPage(allSts.data.page);
      setPages(allSts.data.totalPage);
      setRows(allSts.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  function dhm(t) {
    var cd = 24 * 60 * 60 * 1000,
      ch = 60 * 60 * 1000,
      d = Math.floor(t / cd),
      h = Math.floor((t - d * cd) / ch),
      m = Math.round((t - d * cd - h * ch) / 60000),
      pad = function (n) {
        return n < 10 ? "0" + n : n;
      };
    if (m === 60) {
      h++;
      m = 0;
    }
    if (h === 24) {
      d++;
      h = 0;
    }
    return d;
  }

  const getKolektor = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/kolektors`, {
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setKolektors(response.data);
    setLoading(false);
  };

  const getStById = async () => {
    setLoading(true);
    if (id) {
      const response = await axios.post(`${tempUrl}/sts/${id}`, {
        id: user._id,
        token: user.token,
      });
      setIsStsExist(true);
      setNoSt(response.data.noSt);
      setTglSt(formatDate(response.data.tglSt));
      setTglStDate(response.data.tglSt);
      setNoJual(response.data.noJual);
      setNamaKolektor(response.data.kodeKolektor.namaKolektor);
      setKodeKolektor(
        `${response.data.kodeKolektor.kodeKolektor} - ${response.data.kodeKolektor.namaKolektor}`
      );
      setAngPerBulan(response.data.angPerBulan);
      setJmlBlnTelat(response.data.jmlBlnTelat);
      setTotalDenda(response.data.totalDenda);
      setBiayaTarik(response.data.biayaTarik);
      setTanggalJual(response.data.idJual.tanggalJual);
      setNoAngsuran(response.data.noAngsuran);
      setTenor(response.data.idJual.tenor);
      setNamaRegister(response.data.idJual.namaRegister);
      setTahun(response.data.idJual.tahun);
      setNamaWarna(response.data.idJual.namaWarna);
      setNoRangka(response.data.idJual.noRangka);
      setNoMesin(response.data.idJual.noMesin);

      setAlmRegister(response.data.idJual.almRegister);
      setTlpRegister(response.data.idJual.tlpRegister);
      setNopol(response.data.idJual.nopol);

      const pickedTipe = await axios.post(`${tempUrl}/tipesByKode`, {
        kodeTipe: response.data.idJual.tipe,
        id: user._id,
        token: user.token,
      });

      setMerk(pickedTipe.data.merk);
      setIsi(pickedTipe.data.isi);
      setKodeTipe(response.data.idJual.tipe);

      const allAngsuransByNoJual = await axios.post(
        `${tempUrl}/angsuransByNoJualAllCabang`,
        {
          noJual: response.data.idJual.noJual,
          id: user._id,
          token: user.token,
        }
      );
      setTglJatuhTempo(
        new Date(
          allAngsuransByNoJual.data.angsuran[
            response.data.noAngsuran - 1
          ].tglJatuhTempo
        )
      );

      var d1 = new Date(response.data.tglSt); //"now"
      d1.setHours(0, 0, 0, 0);
      var d2 = new Date(
        allAngsuransByNoJual.data.angsuran[
          response.data.noAngsuran - 1
        ].tglJatuhTempo
      ); // some date
      d2.setHours(0, 0, 0, 0);
      var diff = Math.abs(d1 - d2); // difference in milliseconds
      var total = dhm(diff);
      console.log("total");
      console.log(total);

      setKeterlambatan(total);

      let tempTotalDenda = 0;

      const allAngsuransByNoJualHistory = await axios.post(
        `${tempUrl}/angsuransByNoJualHistory`,
        {
          dendaPersenSetting: setting.dendaPersenSetting,
          perTgl: new Date(response.data.tglSt),
          noJual: response.data.idJual.noJual,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );
      for (let angsuran of allAngsuransByNoJualHistory.data) {
        if (angsuran.dendaNumber > 0) {
          if (angsuran.bayarNumber === 0) {
            tempTotalDenda += angsuran.dendaNumber;
          }
        }
      }
      console.log("tempTotalDenda");
      console.log(tempTotalDenda);
      setDenda(tempTotalDenda);

      console.log("response.data.noAngsuran");
      console.log(response.data.noAngsuran);
      if (response.data.noAngsuran - 2 !== 0) {
        // Find Hutang Denda Before
        let tempHutangDendaBefore =
          allAngsuransByNoJual.data.angsuran[response.data.noAngsuran - 2]
            .hutangDenda;
        setHutangDendaBefore(tempHutangDendaBefore);
        console.log("tempHutangDendaBefore");
        console.log(tempHutangDendaBefore);
      }
    }
    setLoading(false);
  };

  const filterKolektor = async (value) => {
    let kodeKolektor = value.split(" ", 1)[0];
    setKodeKolektorInput(kodeKolektor);

    if (value.length === 0) {
      getStsData();
      getKolektor();
      setKodeKolektorInput("");
      return;
    }

    const pickedKolektor = await axios.post(`${tempUrl}/kolektorByKode`, {
      kodeKolektor,
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });

    let tempKodeKolektor;
    if (pickedKolektor.data) {
      tempKodeKolektor = pickedKolektor.data._id;
    }

    if (pickedKolektor.data) {
      let allSts;
      switch (value) {
        case "Sudah Bayar":
          allSts = await axios.post(
            `${tempUrl}/stsPaginationSudahBayar?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
              kodeCabang: user.cabang._id,
            }
          );
          break;
        case "Belum Bayar":
          allSts = await axios.post(
            `${tempUrl}/stsPaginationBelumBayar?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
              kodeCabang: user.cabang._id,
            }
          );
          break;
        case "PP":
          allSts = await axios.post(
            `${tempUrl}/stsPaginationSudahDitarik?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
              kodeCabang: user.cabang._id,
            }
          );
          break;
        case "Tarik/Titip":
          allSts = await axios.post(
            `${tempUrl}/stsPaginationTitip?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
              kodeCabang: user.cabang._id,
            }
          );
          break;
        default:
          allSts = await axios.post(
            `${tempUrl}/stsPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
            {
              kodeKolektor: tempKodeKolektor,
              id: user._id,
              token: user.token,
              kodeCabang: user.cabang._id,
            }
          );
          break;
      }

      setKodeKolektorInput(kodeKolektor);
      setQuery(searchTerm);
      setStsData(allSts.data.suratPenarikans);
      setPage(allSts.data.page);
      setPages(allSts.data.totalPage);
      setRows(allSts.data.totalRows);
    }
  };

  const deleteSt = async (id) => {
    try {
      setLoading(true);
      var date = new Date();
      var current_date =
        date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
      var current_time =
        date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

      // Find Jual
      const findJualByNoJual = await axios.post(`${tempUrl}/jualByNoJual`, {
        noJual,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      // Find Angsuran
      const angsuran = await axios.post(`${tempUrl}/angsuransByNoJual`, {
        noJual,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      // Find Angsuran Terakhir
      const findAngsuranTerakhir = await axios.post(
        `${tempUrl}/angsuransChild`,
        {
          noJual,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );
      // Find ST By No Jual No Angsuran
      const findStByNoJualNoAngsuran = await axios.post(
        `${tempUrl}/stByNoJualNoAngsuran`,
        {
          noJual,
          noAngsuran: findAngsuranTerakhir.data._id,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );

      // Make Update Jual Content
      let tempUpdateJual = {
        tglStTerakhir: "",
        kodeKolektor: "",
        kodeCabang: user.cabang._id,
        id: user._id,
        token: user.token,
      };

      // Make Update Angsuran Content
      let tempUpdateAngsuran = {
        angsuranKe: findAngsuranTerakhir.data._id - 1,
        biayaTarik: 0,
        suratPenarikan: null,

        _id: findAngsuranTerakhir.data._id,
        tglJatuhTempo: findAngsuranTerakhir.data.tglJatuhTempo,
        angModal: findAngsuranTerakhir.data.angModal,
        angBunga: findAngsuranTerakhir.data.angBunga,
        angPerBulan: findAngsuranTerakhir.data.angPerBulan,
        tglBayar: findAngsuranTerakhir.data.tglBayar,
        noKwitansi: findAngsuranTerakhir.data.noKwitansi,
        keterangan: findAngsuranTerakhir.data.keterangan,
        denda: findAngsuranTerakhir.data.denda,
        potongan: findAngsuranTerakhir.data.potongan,
        jemputan: 0,
        hutangDenda: findAngsuranTerakhir.data.hutangDenda,
        totalPiutang: findAngsuranTerakhir.data.totalPiutang,
        totalBayar: findAngsuranTerakhir.data.totalBayar,
        bayar: findAngsuranTerakhir.data.bayar,

        tglUpdate: current_date,
        jamUpdate: current_time,
        userUpdate: user.username,
        id: user._id,
        token: user.token,
      };

      // Delete St Transaction
      await axios.post(`${tempUrl}/deleteStTransaction`, {
        stData: {
          idSt: id,
          id: user._id,
          token: user.token,
        },
        findStData: {
          noJual,
          noAngsuran: findAngsuranTerakhir.data._id,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        },
        jualData: {
          idJual: findJualByNoJual.data._id,
          ...tempUpdateJual,
        },
        angsuranData: {
          idAngsuran: angsuran.data._id,
          ...tempUpdateAngsuran,
        },
        id: user._id,
        token: user.token,
      });

      setNoSt("");
      setTglSt("");
      setNoJual("");
      setKodeKolektor("");
      setAngPerBulan("");
      setJmlBlnTelat("");
      setTotalDenda("");
      setBiayaTarik("");
      setLoading(false);
      navigate("/suratPenarikan");
      getStsData();
    } catch (error) {
      console.log(error);
    }
  };

  const downloadPdf = async () => {
    let tempY = 14; //-8-7-4
    let tempTglSt = new Date(tglStDate);
    let tempNameMonthTglSt = findMonth(tempTglSt.getMonth() + 1);
    let tempTanggalJual = new Date(tanggalJual);
    let tempNameMonthTanggalJual = findMonth(tempTanggalJual.getMonth() + 1);

    const doc = new jsPDF();
    doc.setFontSize(13);
    doc.setFont(undefined, "bold");
    doc.text(`SURAT PENARIKAN / PENGAMBILAN KEMBALI KENDARAAN`, 40, tempY);
    doc.line(40, tempY + 2, 175, tempY + 2);
    doc.setFont(undefined, "normal");
    doc.setFontSize(11);
    tempY += 15;
    doc.text(`Nomor : ${noSt}`, 20, tempY);
    doc.text(`JAKARTA, ${tglSt}`, 186, tempY, {
      align: "right",
    });
    tempY += 15;
    doc.text(`Dengan Hormat,`, 20, tempY);
    tempY += 6;
    doc.text(
      `Sehubungan dengan tunggakan pembayaran Saudara/i atas pembelian secara sewa beli`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `1 ( satu ) unit sepeda motor dengan rincian sebagai berikut :`,
      20,
      tempY
    );
    tempY += 10;
    doc.text(`Merk / Tipe`, 20, tempY);
    doc.text(`: ${merk} / ${kodeTipe}`, 50, tempY);

    doc.text(`Nama Penyewa`, 105, tempY);
    doc.text(`: ${namaRegister}`, 140, tempY);
    tempY += 6;
    doc.text(`Tahun`, 20, tempY);
    doc.text(`: ${tahun}`, 50, tempY);

    doc.text(`Masa Tunggakan`, 105, tempY);
    doc.text(`: ${jmlBlnTelat} (BULAN)`, 140, tempY);
    tempY += 6;
    doc.text(`Warna`, 20, tempY);
    doc.text(`: ${namaWarna}`, 50, tempY);

    doc.text(`Cicilan perbulan`, 105, tempY);
    doc.text(`:`, 140, tempY);
    doc.text(`${angPerBulan.toLocaleString("en-US")}`, 180, tempY, {
      align: "right",
    });
    tempY += 6;
    doc.text(`No. Rangka`, 20, tempY);
    doc.text(`: ${noRangka}`, 50, tempY);

    doc.text(`Denda Tunggakan`, 105, tempY);
    doc.text(`:`, 140, tempY);
    doc.text(
      `${(parseInt(denda) + parseInt(hutangDendaBefore)).toLocaleString(
        "en-US"
      )}`,
      180,
      tempY,
      {
        align: "right",
      }
    );
    tempY += 6;
    doc.text(`No. Mesin`, 20, tempY);
    doc.text(`: ${noMesin}`, 50, tempY);

    doc.text(`Jumlah Tunggakan`, 105, tempY);
    doc.text(`:`, 140, tempY);
    doc.text(
      `${(angPerBulan + totalDenda).toLocaleString("en-US")}`,
      180,
      tempY,
      {
        align: "right",
      }
    );
    tempY += 6;
    doc.text(`No. Polisi`, 20, tempY);
    doc.text(`: ${nopol}`, 50, tempY);

    tempY += 15;
    doc.text(
      `Sesuai Surat Perjanjian No.       ${noJual}       Tanggal ${formatDate(
        tempTanggalJual
      )}`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `Maka dengan ini sepeda motor tersebut kami ambil kembali / tarik ke kantor kami dengan`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(`kondisi sebagai berikut :`, 20, tempY);

    tempY += 6;
    doc.setFont(undefined, "bold");
    doc.text(
      `Angsuran Ke ${noAngsuran} Dari ${tenor} , terlambat ${keterlambatan} hari`,
      20,
      tempY
    );
    doc.setFont(undefined, "normal");

    tempY += 10;
    doc.text(`Biaya Penarikan     : 200,000`, 20, tempY);
    tempY += 6;
    doc.text(
      `Untuk penyelesaian selanjutnya kami harap Saudara/i dapat segera datang ke kantor`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `kami selambat-lambatnya 7 (tujuh) hari terhitung sejak tanggal surat ini.`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `Apabila Saudara/i tidak datang sampai batas waktu di atas, maka Hak Kepemilikan atas`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `sepeda motor tersebut adalah milik kami sepenuhnya, sesuai Surat Perjanjian yang telah`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(`Ditandatangani bersama.`, 20, tempY);

    tempY += 10;
    doc.text(
      `Demikian disampaikan, sambil menunggu kedatangan Saudara/i terlebih dahulu kami`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(`ucapkan Terima Kasih atas perhatiannya.`, 20, tempY);

    tempY += 10;
    doc.text(`Diserahkan Oleh,`, 50, tempY);
    doc.text(`Hormat Kami,`, 130, tempY);
    tempY += 20;
    doc.text(`__________________`, 45, tempY);
    doc.text(`__________________`, 124, tempY);
    tempY += 6;
    doc.text(`${setting.namaPemilik.split(" ")[0]}`, 135, tempY);

    window.open(URL.createObjectURL(doc.output("blob")));
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Piutang</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Surat Penarikan
      </Typography>
      {isStsExist && (
        <Box sx={downloadButtons}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={() => downloadPdf()}>
              CETAK
            </Button>
          </ButtonGroup>
        </Box>
      )}
      <Box sx={buttonModifierContainer}>
        {user.tipeUser !== "OWN/DIREKSI" && (
          <ButtonModifier
            id={id}
            kode={isStsExist}
            addLink={`/suratPenarikan/tambahSuratPenarikan`}
            editLink={`/suratPenarikan/${id}/edit`}
            deleteUser={deleteSt}
            nameUser={noJual}
          />
        )}
      </Box>
      <FormControl sx={{ marginTop: 1 }}>
        <FormLabel id="demo-controlled-radio-buttons-group">Filter</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          defaultValue="Semua"
          value={value}
          onChange={handleChangeFilter}
        >
          <FormControlLabel
            value="Sudah Bayar"
            control={<Radio />}
            label="Sudah Bayar"
          />
          <FormControlLabel
            value="Belum Bayar"
            control={<Radio />}
            label="Belum Bayar"
          />
          <FormControlLabel value="PP" control={<Radio />} label="PP" />
          <FormControlLabel
            value="Tarik/Titip"
            control={<Radio />}
            label="Tarik/Titip"
          />
          <FormControlLabel value="Semua" control={<Radio />} label="Semua" />
        </RadioGroup>
      </FormControl>
      {user.tipeUser !== "EKS" && user.tipeUser !== "OWN/DIREKSI" && (
        <>
          <hr />
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Kode Eksekutor :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={kolektorOptions}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        placeholder="SEMUA EKSEKUTOR"
                        {...params}
                      />
                    )}
                    onInputChange={(e, value) => filterKolektor(value)}
                    inputValue={kodeKolektorInput}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
        </>
      )}
      <hr />
      {isStsExist && (
        <>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      No. Jual :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={noJual} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      No. Surat Penarikan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={noSt} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Tgl. Surat Penarikan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={tglSt} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Eksekutor :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={kodeKolektor} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Total :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={(biayaTarik + totalDenda).toLocaleString(
                          "en-US"
                        )}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Jml Bulan Telat :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={`${jmlBlnTelat} bulan`} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Angsuran / Bulan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={angPerBulan.toLocaleString("en-US")}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Denda Tunggakan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={totalDenda.toLocaleString("en-US")}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Biaya Tarik :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={biayaTarik.toLocaleString("en-US")}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
          </Box>
          <Divider sx={dividerStyle} />
        </>
      )}
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={{ mt: 2 }}>
        <Chip
          label="Belum Bayar"
          sx={{
            backgroundColor: Colors.red400,
          }}
        />
        <Chip
          label="PP"
          sx={{
            backgroundColor: Colors.yellow400,
          }}
        />
        <Chip
          label="Tarik/Titip"
          sx={{
            backgroundColor: Colors.blue300,
          }}
        />
      </Box>
      <Box sx={tableContainer}>
        <ShowTableSuratPenarikan
          currentPosts={stsData}
          tipeUser={user.tipeUser}
        />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilSuratPenarikan;

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};
